import { FeatureToggle, ListFeatureTogglesResponse } from "src/app/hickory-api";
import { PascalKeys } from "../pascal-keys";
import { toFriendlyString } from "./utility";

//#region FeatureToggles
export type PascalFeatureToggle = PascalKeys<FeatureToggle>;

export interface FeatureToggleItem {
  key: string;
  title?: string;
  description?: string;
  group?: string;
}

export interface ToggleGroup {
  name: string;
  toggles: FeatureToggleItem[];
}

export interface ToggleGroupStrings {
  name: string;
  toggles: string[];
}

export function getPascalFeatureToggles(r: ListFeatureTogglesResponse) {
  return (r.items || []) as unknown as PascalFeatureToggle[];
}

export function toFeatureToggleItems(toggles: PascalFeatureToggle[]): FeatureToggleItem[] {
  return toggles.map(t => ({
    key: t.Key ?? '',
    title: t.Title,
    description: t.Description,
    group: t.Group,
  }));
}

export function toFeatureToggleGroups(toggles: FeatureToggleItem[]): ToggleGroup[] {
  const groupMap = new Map<string, FeatureToggleItem[]>();
  for (const toggle of toggles) {
    const g = toggle.group ?? '';
    if (!groupMap.has(g)) groupMap.set(g, []);
    groupMap.get(g).push(toggle);
  }
  return Array.from(groupMap.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([name, items]) => ({
      name: name ? toFriendlyString(name) : 'General',
      toggles: [...items].sort((a, b) =>
        (a.title ?? a.key).localeCompare(b.title ?? b.key)
      ),
    }));
}

export function fromFeatureToggleResponseToGroups(r: ListFeatureTogglesResponse): ToggleGroup[] {
  const toggles = getPascalFeatureToggles(r);
  const items = toFeatureToggleItems(toggles);
  return toFeatureToggleGroups(items);
}

export function fromFeatureToggleResponseToStringGroups(r: ListFeatureTogglesResponse): ToggleGroupStrings[] {
  const groups = fromFeatureToggleResponseToGroups(r);
  return groups.map(g => ({
    name: g.name,
    toggles: g.toggles.map(t => t.key),
  }));
}

//#endregion FeatureToggles